module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_vizija_mobile-c3b2c8a394d81de86f0bb4b7e41e40c6.png";